<!-- 易可图操作 -->
<template>
    <DraggableDialog title="图片操作" :visible.sync="_showDialog" :closeOnEsc="false" :closeOnClickMask="false"
        :fullscreen="false" :width="clientWidth" :height="clientHeight" @close="cancel">
        <div id="ykt-editor" v-show="actionFunction == 'initPhotoEditor'"></div>
        <div id="ykt-editors" v-show="actionFunction == 'initPhotoEditors'"></div>
        <div id="ykt-aieditor" v-show="actionFunction == 'initAIEditor'"></div>
        <div ref="watermarkEditor" v-show="actionFunction == 'initWatermarkEditor'" id="ykt-watermark-editor"
            class="ykt-editor-panel"></div>
    </DraggableDialog>
</template>

<script>
import DraggableDialog from './settings/DraggableDialog.vue';
import {
    buildBitImageSerializeData,
    buildBitImageSerializeDataFromSavePageData,
    enableYktDebug,
    getPosterLoadOptionsForPortal,
    isBitImageSerializeData,
    logYktDebug,
    logYktSerializeData,
    pickBitImagePageData,
    prepareBitImageSerializeDataForLoad,
    WATERMARK_CANVAS_SIZE,
    withCacheBust,
} from '@/utils/watermarkPoster.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
    components: {
        DraggableDialog
    },
    data() {
        return {
            clientHeight: 0,
            clientWidth: 0
        }
    },
    computed: {
        ...mapState("ykt", ["showEdit", "websdk", "currentUrl", "actionFunction", "actionConfig", "multiEdit", "multiUrls"]),
        _showDialog: {
            get() {
                return this.showEdit;
            },
            set(value) {
                this.UPDATE_SHOW_EDIT(value)
            }
        }
    },
    watch: {
        _showDialog(val) {
            if (val) {
                console.log("打开易可图编辑器", this.actionFunction);
                this.loadWebSdk();
            }
        }
    },
    mounted() {
        this.getClientRect();
    },
    methods: {
        ...mapMutations("ykt", ["SET_WEBSDK", "UPDATE_SHOW_EDIT", "SET_YKT_WRAPPER", "CLEAR_YKT_WRAPPER"]),
        ...mapActions("ykt", ["initWebSdk", "getEditWrapper"]),
        getClientRect() {
            this.clientHeight = Math.floor(window.innerHeight * 0.9);
            this.clientWidth = Math.floor(window.innerWidth * 0.9);
        },
        async loadWebSdk() {
            await this.initWebSdk();
            // 初始化ykt
            this.$nextTick(() => {
                const delay = this.actionFunction === 'initWatermarkEditor' ? 600 : 300;
                setTimeout(() => {
                    this.actionFunction && this[this.actionFunction]?.();
                }, delay);
            })
        },
        async applyInitPanel(photoEditor) {
            const panel = this.actionConfig?.initPanel;
            if (!panel?.name || !photoEditor) {
                return;
            }
            // 加载图片后再切面板，避免 initPanel 被 load 冲掉；复用实例也靠 openPanel
            if (typeof photoEditor.openPanel !== "function") {
                return;
            }
            try {
                await photoEditor.openPanel(panel);
            } catch (err) {
                console.warn("易可图 openPanel 失败", panel, err);
            }
        },
        async initPhotoEditor() {
            const editorContainer = document.querySelector('#ykt-editor')
            if (!editorContainer) {
                return
            }
            editorContainer.style.height = this.clientHeight - 55 + 'px';
            editorContainer.style.width = this.clientWidth - 15 + 'px';
            // 初始化编辑器实例
            try {
                let photoEditor = await this.getEditWrapper();

                if (!photoEditor) {
                    const openOpts = {
                        container: editorContainer,
                        config: {
                            saveText: '保存',
                            backButton: false, // 是否显示返回按钮
                            authorize: this.getOperateCode,
                            /**是否显示分享按钮 */
                            share: false,
                            sizeConfig: {}, // 参考尺寸配置
                        },
                    };
                    if (this.actionConfig?.initPanel?.name) {
                        openOpts.initPanel = this.actionConfig.initPanel;
                    }
                    photoEditor = await this.websdk.openPhotoEditor(openOpts)
                    this.SET_YKT_WRAPPER({ action: this.actionFunction, wrapper: photoEditor });
                }
                console.log("打开 initPhotoEditor", this.currentUrl, this.actionConfig?.initPanel);
                // 编辑器初始化完成，可进行加载图片等操作
                let url=(this.currentUrl.includes("?")?(this.currentUrl+"&t="+Date.now()):(this.currentUrl+"?t="+Date.now()))
                await photoEditor.loadByImageUrl(url);
                await this.applyInitPanel(photoEditor);

                // 注册事件监听器
                photoEditor.on('save', this.sumbit)
            } catch (err) {
                console.error(err)
            }
        },
        async initPhotoEditors() {
            const editorContainer = document.querySelector('#ykt-editors')
            if (!editorContainer) {
                return
            }
            editorContainer.style.height = this.clientHeight - 55 + 'px';
            editorContainer.style.width = this.clientWidth - 15 + 'px';
            // 初始化编辑器实例
            try {
                let photoEditor = await this.getEditWrapper();

                if (!photoEditor) {
                    const openOpts = {
                        container: editorContainer,
                        config: {
                            saveText: '保存',
                            backButton: false, // 是否显示返回按钮
                            authorize: this.getOperateCode,
                            /**是否显示分享按钮 */
                            share: false,
                            sizeConfig: {}, // 参考尺寸配置
                            multipleImagesEnable: this.multiEdit,
                            autoEnableBatch: true,
                            /**开启多图导航的复制 */
                            navCopyEnable: true,
                            /**开启多图导航的添加图片e */
                            navAddPhotoEnable: false
                        },
                    };
                    if (this.actionConfig?.initPanel?.name) {
                        openOpts.initPanel = this.actionConfig.initPanel;
                    }
                    photoEditor = await this.websdk.openPhotoEditor(openOpts)
                    this.SET_YKT_WRAPPER({ action: this.actionFunction, wrapper: photoEditor });
                }
                // 编辑器初始化完成，可进行加载图片等操作
                if (this.multiEdit) {
                    console.log("打开 initPhotoEditors", this.multiUrls);
                    let nurl=this.multiUrls.map(it=>{
                        return {
                            ...it,
                            url: (it.url.includes("?")?(it.url+"&t="+Date.now()):(it.url+"?t="+Date.now()))
                        };
                    });
                    await photoEditor.loadImages(nurl);
                }
                await this.applyInitPanel(photoEditor);

                // 注册事件监听器
                photoEditor.on('save', this.sumbit)
            } catch (err) {
                console.error(err)
            }
        },
        getWatermarkPosterConfig() {
            const cfg = this.actionConfig || {};
            const config = {
                saveText: '保存',
                backButton: false,
                authorize: this.getOperateCode,
                share: false,
                moduleSettings: {
                    hotlink: false,
                    priceLabel: false,
                    component: false,
                    tool: false,
                    qrcode: false,
                    stackTable: false,
                    postersNav: false,
                    sizeSetting: true,
                    posterBackgroundSetting: true,
                    watermarkPreview: false,
                    template: true,
                    text: true,
                    material: true,
                    picture: true,
                    watermark: true,
                    border: false,
                    showImportPsd: false,
                },
                posterTplFilterSubType: 'watermark',
                sidebarItems: [
                    { key: 'Template', sort: 1 },
                    { key: 'Text', sort: 2 },
                    { key: 'Material', sort: 3 },
                    { key: 'Picture', sort: 4 },
                    { key: 'Watermark', sort: 5 },
                ],
            };
            if (cfg.sourceImageUrl && !prepareBitImageSerializeDataForLoad(cfg.pageData, null)) {
                const url = withCacheBust(cfg.sourceImageUrl);
                config.customPickReplaceImage = async () => url;
                config.customImageUpload = async (file, onProgress) => {
                    if (onProgress) {
                        onProgress({ loaded: 1, total: 1 });
                    }
                    return url;
                };
            }
            return config;
        },
        getBlankWatermarkStage(portal) {
            const p = portal || { width: WATERMARK_CANVAS_SIZE, height: WATERMARK_CANVAS_SIZE };
            return {
                portal: { width: p.width, height: p.height },
            };
        },
        bindPosterEditorDebug(posterEditor) {
            const events = ['error', 'save', 'back', 'userActions', 'customFunctionButtonClick'];
            events.forEach((name) => {
                posterEditor.on(name, (payload) => {
                    logYktDebug(`posterEditor:${name}`, payload);
                });
            });
        },
        async loadWatermarkEditorContent(posterEditor, cfg) {
            enableYktDebug();
            const portal = cfg.canvasPortal || { width: WATERMARK_CANVAS_SIZE, height: WATERMARK_CANVAS_SIZE };
            const loadOptions = getPosterLoadOptionsForPortal(portal);
            logYktDebug('loadWatermarkEditorContent:start', {
                sourceImageUrl: cfg.sourceImageUrl,
                hasBitImagePageData: isBitImageSerializeData(cfg.pageData),
                savedAttrs: cfg.pageData?.children?.[0]?.attrs,
                portal,
            });

            const serializeData = prepareBitImageSerializeDataForLoad(cfg.pageData, cfg.sourceImageUrl);
            if (serializeData) {
                window.__YKT_LAST_PAGE_DATA__ = serializeData;
                logYktSerializeData('loadByConfig (恢复完整 attrs)', serializeData, { loadOptions });
                await posterEditor.loadByConfig(serializeData, loadOptions);
                logYktDebug('loadByConfig:bitImage:restore:done', {
                    attrs: serializeData.children?.[0]?.attrs,
                });
                return;
            }

            if (!cfg.sourceImageUrl) {
                const blankStage = this.getBlankWatermarkStage(portal);
                await posterEditor.loadPosters([blankStage]);
                logYktDebug('loadPosters:blank:done', { stage: blankStage });
                return;
            }

            // 首次注入：原始 logo 居中
            try {
                const { config: serializeData } = await buildBitImageSerializeData(cfg.sourceImageUrl, portal, {
                    fillPortal: false,
                });
                window.__YKT_LAST_PAGE_DATA__ = serializeData;
                logYktSerializeData('loadByConfig (首次 BitImage)', serializeData, { loadOptions });
                await posterEditor.loadByConfig(serializeData, loadOptions);
                logYktDebug('loadByConfig:bitImage:first:done');
            } catch (err) {
                logYktDebug('loadWatermarkEditorContent:imageFallback', {
                    message: err?.message,
                    stack: err?.stack,
                });
                console.error('海报编辑器自动载入水印图失败，请手动添加', err);
                await posterEditor.openPanel({ name: 'PICTURE' });
                this.$message.warning('图片未自动载入，请点击左侧「图片」→「上传」添加');
            }
        },
        async initWatermarkEditor() {
            await this.$nextTick();
            const editorContainer = this.$refs.watermarkEditor;
            if (!editorContainer) {
                return;
            }
            editorContainer.style.height = this.clientHeight - 55 + 'px';
            editorContainer.style.width = this.clientWidth - 15 + 'px';
            const cfg = this.actionConfig || {};
            try {
                let posterEditor = await this.getEditWrapper();
                if (posterEditor?.destroy) {
                    posterEditor.destroy();
                }
                this.CLEAR_YKT_WRAPPER();
                posterEditor = await this.websdk.openPosterEditor({
                    container: editorContainer,
                    initPanel: cfg.sourceImageUrl && !prepareBitImageSerializeDataForLoad(cfg.pageData, cfg.sourceImageUrl)
                        ? { name: 'PICTURE' }
                        : undefined,
                    config: this.getWatermarkPosterConfig(),
                });
                this.SET_YKT_WRAPPER({ action: this.actionFunction, wrapper: posterEditor });
                this.bindPosterEditorDebug(posterEditor);
                posterEditor.on('save', this.sumbit);
                posterEditor.on('error', (err) => {
                    console.error('易可图海报编辑器错误', err);
                    this.$message.error(err?.message || '易可图加载失败');
                });
                await new Promise((resolve) => setTimeout(resolve, 300));
                await this.loadWatermarkEditorContent(posterEditor, cfg);
            } catch (err) {
                console.error(err);
                this.$message.error(err?.message || '易可图水印编辑器打开失败');
            }
        },
        async initAIEditor() {
            const editorContainer = document.querySelector('#ykt-aieditor')
            if (!editorContainer) {
                return
            }
            editorContainer.style.height = this.clientHeight - 55 + 'px';
            editorContainer.style.width = this.clientWidth - 15 + 'px';
            // 初始化编辑器实例
            try {
                let photoEditor = await this.getEditWrapper();
                if (!photoEditor) {
                    photoEditor = await this.websdk.openAIEditor({
                        container: editorContainer,
                        config: {
                            copyBtnText: '一键复制',
                            authorize: this.getOperateCode,

                            moduleSettings: {}, // 参考模块配置
                            presetConfig: {}, // 参考预设
                        },
                    })
                    this.SET_YKT_WRAPPER({ action: this.actionFunction, wrapper: photoEditor });
                }
                await photoEditor.setModules({
                    productPicture: {
                        productPictureUpload: false,
                        liteMode: true,
                    }
                })
                let url=(this.currentUrl.includes("?")?(this.currentUrl+"&t="+Date.now()):(this.currentUrl+"?t="+Date.now()))
                // 添加单张图片
                await photoEditor.setProductPictureUrl(url)

                // 监听海报编辑事件
                photoEditor.on('productPictureResultItemClick', this.sumbit)
            } catch (err) {
                console.error(err)
            }
        },
        // 获取一次性操作码
        async getOperateCode() {
            const user = this.getUserInfo();
            // console.log("====================user",user)
            if (!user?.isvUserId) {
                this.$message.error('易可图授权失败，请先登录账号');
                return null;
            }
            let token = await this.$call.invoke('YKT.getAccessToken', user.isvUserId);
            console.log("====================token",token)
            if (token) {
                let opRes = await this.$call.invoke('YKT.getOperateCode', token)
                if (opRes.code == 200 && opRes.result == "success") {
                    return opRes.data.operateCode;
                }
            }
            this.$message.error('易可图授权失败，请稍后重试');
            return null;
        },
        getUserInfo: function () {
            let user = this.$utils.get("user-info");
            if (user) {
                return user;
            }
            if (window.require) {
                return this.$call.sendSync("session.getUser");
            }
        },
        cancel() {
            this.teardownEditor();
            this.$emit("cancel")
        },
        async teardownEditor() {
            const editor = await this.getEditWrapper();
            if (editor?.destroy) {
                editor.destroy();
            }
            this.CLEAR_YKT_WRAPPER();
        },
        async sumbit(payload) {
            let result = payload;
            if (this.actionFunction === 'initWatermarkEditor') {
                const portal = this.actionConfig?.canvasPortal || {
                    width: WATERMARK_CANVAS_SIZE,
                    height: WATERMARK_CANVAS_SIZE,
                };
                const sourceImageUrl = this.actionConfig?.sourceImageUrl || null;
                const savePageData = payload;
            
                const bitImagePageData = buildBitImageSerializeDataFromSavePageData(
                    savePageData,
                    sourceImageUrl,
                    portal,
                );
                if (bitImagePageData) {
                    logYktSerializeData('save BitImage pageData (serialization attrs)', bitImagePageData, {
                        currentStageId: payload?.currentStageId,
                        sourceImageUrl,
                        savedAttrs: bitImagePageData.children?.[0]?.attrs,
                    });
                    result = {
                        ...payload,
                        pageData: bitImagePageData,
                        bitImagePageData,
                    };
                }
            }
            this.$emit('submit', result);
        },
    },
    destroyed() {
        this.teardownEditor();
    }
}
</script>

<style scoped>
.ykt-editor-panel {
    width: 100%;
    min-height: 600px;
}

.dialog-close {
    position: absolute;
    top: -8px;
    right: -8px;
    height: 20px;
    width: 20px;
    cursor: pointer;
    text-align: center;
    border-radius: 20px;
    color: #fff;
    background-color: #f45057;
    font-size: 16px;
    border: 2px solid #ffffff;
    z-index: 99;
}
</style>